/**
 * This module defines most of the Typescript interfaces and type aliases used by Kryo.
 *
 * @module kryo/core
 */
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ReporterContext_path, _ReporterContext_checks;
import { format } from "./checks/index.mjs";
export { enter, writeCheck, writeError } from "./_helpers/context.mjs";
export { format as formatCheck };
export const NOOP_CONTEXT = {
  write() {
    return 0;
  },
  enter(_key, cb) {
    return cb();
  }
};
export class ReporterContext {
  constructor() {
    _ReporterContext_path.set(this, void 0);
    _ReporterContext_checks.set(this, void 0);
    __classPrivateFieldSet(this, _ReporterContext_path, [], "f");
    __classPrivateFieldSet(this, _ReporterContext_checks, [], "f");
  }
  write(check) {
    const id = __classPrivateFieldGet(this, _ReporterContext_checks, "f").length;
    __classPrivateFieldGet(this, _ReporterContext_checks, "f").push({
      path: [...__classPrivateFieldGet(this, _ReporterContext_path, "f")],
      check
    });
    return id;
  }
  enter(key, cb) {
    const oldLen = __classPrivateFieldGet(this, _ReporterContext_path, "f").length;
    __classPrivateFieldGet(this, _ReporterContext_path, "f").push(key);
    try {
      return cb();
    } finally {
      __classPrivateFieldGet(this, _ReporterContext_path, "f").length = oldLen;
    }
  }
  /**
   * Close the context and throw an error
   */
  throw(id) {
    throw new Error(this.report(id) ?? "(empty `kryo` report)");
  }
  /**
   * Close the context and report it as a string
   */
  report(id) {
    const lines = [];
    const written = new Set();
    const pending = [id];
    while (pending.length > 0) {
      const cur = pending.pop();
      if (written.has(cur)) {
        continue;
      }
      if ((cur | 0) === cur && cur >= 0 && cur < __classPrivateFieldGet(this, _ReporterContext_checks, "f").length) {
        const {
          path,
          check
        } = __classPrivateFieldGet(this, _ReporterContext_checks, "f")[cur];
        const pathStr = path.map(k => {
          if (typeof k === "string" || typeof k === "number") {
            return String(k);
          } else {
            return `Symbol(${String(k)})`;
          }
        }).join(".");
        const msg = format(check);
        lines.push(`${pathStr}#${cur}: ${msg}`);
        for (const child of check.children ?? []) {
          pending.push(child);
        }
      }
    }
    if (lines.length === 0) {
      return null;
    } else {
      return lines.join("\n");
    }
  }
}
_ReporterContext_path = new WeakMap(), _ReporterContext_checks = new WeakMap();
/**
 * Represents an identifier case style.
 *
 * This enum is used when automatically renaming fields and enum variants.
 */
export var CaseStyle;
(function (CaseStyle) {
  /**
   * Capitalize every component except for the first one, then join them without any separator.
   *
   * e.g. `camelCase`
   */
  CaseStyle["CamelCase"] = "camelCase";
  /**
   * Capitalize every component, then join them without any separator.
   *
   * e.g. `PascalCase`
   */
  CaseStyle["PascalCase"] = "PascalCase";
  /**
   * Make every component lowerCase, then join them using `_`.
   *
   * e.g. `snake_case`
   */
  CaseStyle["SnakeCase"] = "snake_case";
  /**
   * Make every component uppercase, then join them using `_`.
   *
   * e.g. `SCREAMING_SNAKE_CASE`
   */
  CaseStyle["ScreamingSnakeCase"] = "SCREAMING_SNAKE_CASE";
  /**
   * Make every component lowerCase, then join them using `-`.
   *
   * e.g. `kebab-case`
   */
  CaseStyle["KebabCase"] = "kebab-case";
})(CaseStyle || (CaseStyle = {}));
export function testOrThrow(type, raw) {
  const {
    ok
  } = type.test(null, raw);
  if (!ok) {
    throw new Error("invalid type");
  }
}
export function readOrThrow(type, reader, raw) {
  const cx = new ReporterContext();
  const {
    ok,
    value
  } = type.read(cx, reader, raw);
  if (ok) {
    return value;
  } else {
    return cx.throw(value);
  }
}
